<template>
    <div class="category-display">
        <GridDisplay
            v-for="(entries, index) in categories"
            :key="index"
            :title="index"
            :entries="entries"
            :search-text="searchText"
        />
    </div>
</template>

<script>
import GridDisplay from "@/components/GridDisplay.vue"
export default {
  name: 'CategoryDisplay',
  props: {
    categories: Object,
    searchText: String,
  },
  components: {
    GridDisplay
  }
}
</script>

<style scoped>
.category-display {
  background-color: red;
  padding: 1px;
}
</style>